module.exports = __webpack_public_path__ + "static/zeus-2416b19c1e892b00d0d166defe5d9052.jpeg";